import type {
  MarketProductsDataSource,
  MarketProductsParams,
} from '~/api/data-source/market-products';
import { marketProductsDataSource } from '~/api/data-source/market-products';
import type { CursorPagedMarketProducts } from '~/api/model';
import { cursorPagedMarketProductsSchema, parseModel } from '~/api/model';

export interface MarketProductsRepository {
  getMarketProducts(
    params: MarketProductsParams,
  ): Promise<CursorPagedMarketProducts>;
  getMarketProductsCount(params: MarketProductsParams): Promise<number>;
}

export class MarketProductsRepositoryImpl implements MarketProductsRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: MarketProductsDataSource = marketProductsDataSource,
  ) {}

  async getMarketProducts(params: MarketProductsParams) {
    const response = await this.dataSource.getMarketProducts(params);
    return parseModel(
      cursorPagedMarketProductsSchema,
      response,
      'CursorPagedMarketProducts',
    );
  }

  async getMarketProductsCount(params: MarketProductsParams) {
    return this.dataSource.getMarketProductsCount(params);
  }
}

export const marketProductsRepository = new MarketProductsRepositoryImpl();
